<template>
  <div class="list-block" :class="[ inline ? 'inline':'', visible ? 'visible' : 'hidden']">
		<div class="list-header">
			<div class="title">{{ $t('print.selected.waitPrint') }}</div>
			<div class="btns">
				<xl-button size="small" @click="handlePrintOutMessageBox" :disabled="checkList.length !== 1"><xl-icon :size="20"><Accuware20></Accuware20></xl-icon>AccuWare</xl-button>
				<xl-button size="small" @click="handleGoSlice" v-if="$store.state.hasSlicePower" :disabled="!checkList.length"><xl-icon :size="20"><Section></Section></xl-icon>{{ $t('user.case.toSlice') }}</xl-button>
			</div>
		</div>
		<div class="list-content">
			<xl-scrollbar v-if="Object.keys( list ).length" >
				<div class="content">
					<div class="model_wrap" v-for="cate in list" :key="cate.productConfigCode">
						<!-- 不同大类 -->
						<div class="type_title"> 
							<div class="title_wrap">{{ cate.productConfig }}</div> 
							<div class="title_opera">
								<div class="title_opera_delete" v-if="cate.checked || cate.indeterminate" @click.prevent="handleDelete( cate )" >
									<i class="iconfont icon-a-1-normal2"></i>{{ $t('button.delete') }}
								</div>
								<div><xl-checkbox v-model="cate.checked" :indeterminate="cate.indeterminate" @change="( val ) => handleCheckAllChange( val, cate )" :disabled="Boolean( checkType &&  checkType !== cate.productConfigCode )">{{ $txdo('design.orderDetail.checkAll') }}</xl-checkbox></div>
							</div>
						</div>
						<div class="check-wrap">
							<xl-checkbox-group v-model="checkList" @change="( val ) => handleCheckedChange( val, cate )" :disabled="Boolean( checkType &&  checkType !== cate.productConfigCode )">
								<xl-checkbox v-for="item in cate.attachs" :key="item.id" :label="item.id" :value="item.id">
									<div class="check-card">
										<div class='left'>
											<img class="img" :src="$getCdnUrl({ bucket:cate.imgBucket,dfsID: cate.imgDfsID })" width="60" alt=""/>
										</div>
										<div class='center'>
											<div class="info">
												<Order />
												<span>
													<xl-tooltip :content="item.name" placement="top">
														{{ item.name }}
													</xl-tooltip>
												</span>
											</div>
											<div class="info">
												<Orderfile />
												<span>
													<xl-tooltip :content="item.fileName" placement="top">
														{{ item.fileName }}
													</xl-tooltip>
												</span>
											</div>
											<div class="info"><CreateTime /><span>{{ $convertUTCDateToLocalDate( item.createOn ) }}</span></div>
										</div>
										<div class='right'>
											<i class="isButton iconfont icon-a-1-normal2" @click.stop.prevent="handleDelete( cate, item.id )"></i>
										</div>
									</div>
								</xl-checkbox>
							</xl-checkbox-group>
						</div>
					</div>
				</div>
			</xl-scrollbar>
			<no-data class="nodata" v-else  :text="$t('common.noData')"></no-data>
		</div>
    	<div class="trigger">
			<img v-if="visible" src="../../assets/image/drawer_close.png" alt="close" @click="toggle" />
			<!-- <img v-else src="../../assets/image/drawer_open.png" alt="open" @click="toggle" /> -->
    	</div>
		<softwareEvoke ref="softwareEvokeRef"></softwareEvoke>
  </div>
</template>

<script setup>
import { XlCheckbox, XlCheckboxGroup, XlButton, XlIcon, XlScrollbar, XlMessageBox, XlTooltip } from '@shining3d/ui-components';
import { Order, Orderfile, CreateTime, Accuware20, Section } from '@shining3d/icons-vue';
import NoData from '../no-data.vue';
import softwareEvoke from '../../components/softwareEvoke/index.vue';
import printApi from '../../api/print.js';
import Bus from '../../utils/bus.js';

import { useLang } from "@shining3d/common-module/utils/lang.js";
import { $lang } from "@shining3d/common-module/utils/index.js";

import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { $getCdnUrl, $convertUTCDateToLocalDate } from '../../utils/common.js';
import _get from 'lodash/get';
import router from '@/router/index';

const props = defineProps({
	inline: {
		type: Boolean,
		default: false
	},
	visible: {
		type: Boolean,
		default: false
	}
});

const emits = defineEmits(['toggle']);

const maxFileSize = _get( window, 'app.global.sliceFile.maxFileSize', 200 * 1024 * 1024 );

const { $t } = useLang( '@shining3d/app' );
const { $t: $txdo } = useLang( '@shining3d/xl-design-order' );

const $store = useStore();
const { id: orgID } = $store.state.factorySelect;

const visible = ref( props.visible );

const list = ref([]);
const checkList = ref([]);
const checkType = ref('');
// 通过接口获取待打印列表
const getList = () => {
	printApi.fetchPreprintList({ lang: $lang(), orgID }).then(( res ) => {
		if ( res.status === 'success' ){
			const arr = ( res.result || []).map(( item ) => ({
				...item,
				attachs: item.attachs.map(( a ) => ({ ...a, productConfigCode: item.productConfigCode, printType: item.printType })) // 塞入参数
			}));
			const flatArr = flattenList( arr ); // 拍平
			if ( addingInfo.value.srcType ) { // add
				let addingItems = [];
				if ( addingInfo.value.sourceID ){
					addingItems = flatArr.filter(( item ) => item.srcID === addingInfo.value.sourceID );
				} else if ( addingInfo.value.attachs ) {
					addingItems = flatArr.filter(( item ) => addingInfo.value.attachs.map(( a ) => a.srcAttachID ).includes( item.srcAttachID ));
				}
				checkList.value = addingItems.map(( item ) => item.id )
				checkType.value = addingItems[ 0 ]?.productConfigCode;
				addingInfo.value = {}; // 重置
			} else { // view
				({ checkList: checkList.value, checkType: checkType.value } = $store.state.designPreprintInfo );
			}
			$store.commit( 'setDesignPreprintInfo', { // 为了不同组件共享状态, 更新信息
				num: flatArr.length,
			})
			list.value = arr.map(( cate ) => ({ // 组装list数据，增加选中状态
				...cate,
				checked: checkType.value === cate.productConfigCode && checkList.value.length === cate.attachs.length,
				indeterminate: checkType.value === cate.productConfigCode && checkList.value.length !== cate.attachs.length && !checkList.value.length
			}));
		}
	})
};
getList();

const flattenList = ( list ) => {
	let arr = [];
	list.forEach(( cate ) => {
		arr = arr.concat( cate.attachs )
	})
	return arr;
}

const toggle = ( flag ) => {
	visible.value = typeof flag === 'boolean' ? flag : !visible.value;
	if( props.inline ){
		Bus.$emit( 'preprintPanelVisible', visible.value );
	} else {
		emits( 'toggle', visible.value );
	}
	
};

Bus.$on( 'togglePreprintPanel', toggle );

watch(() => props.visible, ( newVal ) => {
	visible.value = newVal;
}, { immediate: true });

watch([ () => checkList.value, () => checkType.value ], ( newVal ) => {
	$store.commit( 'setDesignPreprintInfo', { // 为了不同组件共享状态, 更新信息
		checkList: checkList.value,
		checkType: checkType.value
	})
});

const addingInfo = ref({}); // 默认选中添加项, 存储添加信息

Bus.$off( 'addPreprintItem' );
Bus.$on( 'addPreprintItem', ( data ) => {
	const param = {
		orgID,
		srcType: 'dentalxOrder',
		...data
	}
	handleAdd( param );
	toggle( true );
});
// 添加待待打印项
const handleAdd = async ( data ) => {
	if ( data.sourceID ){ // 来源导入（订单），暂时以sourceID来判断
		const { status } = await printApi.addPreprintItemsBySource( data );
		if ( status === 'success' ){
			addingInfo.value = data;
			getList();
		} 
	} else { // 按项添加
		const { status } = await printApi.addPreprintItems( data );
		if ( status === 'success' ){
			addingInfo.value = data;
			Bus.$emit( 'updatePreprintItem' );
			getList();
		} 
	}
};

// 删除待待打印项
const handleDelete = ( cate, id ) => {
	const data = {
		orgID,
		ids: id ? [id] : checkList.value
	}
	XlMessageBox({
		title: $t( 'common.prompt' ),
		type: 'info',
		message: $t( 'case.printFile.deleteDesc' ),
		confirmButtonText: $t( 'button.confirm' ),
		cancelButtonText: $t( 'button.cancel' )
	}).
		then(() => {
			submitToDelete( data, cate );
		}).
		catch(( e ) => {
			console.log( 'catch', e );
		});
};

// 提交删除
const submitToDelete = async ( data, cate, refresh = true ) => {
	const { status } = await printApi.deletePreprintItems( data );
	if ( status === 'success' ){
		checkList.value = checkList.value.filter(( item ) => !data.ids.includes( item ));
		if ( checkType.value === cate?.productConfigCode && data.ids.length === cate?.attachs.length ){ // 该分类下全部删完了
			checkType.value = '';
		}
		if ( refresh ){
			getList();
			Bus.$emit( 'updatePreprintItem' );
		}
	}
}

// 单选
const handleCheckedChange = ( value, cate ) => {
	cate.checked = value.length === cate.attachs.length;
	cate.indeterminate = value.length > 0 && value.length < cate.attachs.length;
	checkType.value = value.length > 0 ? cate.productConfigCode : '';
};

// 多选
const handleCheckAllChange = ( val, cate ) => {
	checkList.value = val ? cate.attachs.map(( a ) => a.id ) : [];
	checkType.value = val ? cate.productConfigCode : '';
	cate.checked = val;
	cate.indeterminate = false;
};

// 去打印
const softwareEvokeRef = ref( null );
const handlePrintOutMessageBox = ( data ) => {
	const info = {
		title: $t( 'user.case.printConfirm' ),
		message: $t( 'user.case.printConfirmTips' )
	};
	XlMessageBox({
		type: 'info',
		title: info.title,
		message: info.message,
		confirmButtonText: $t( 'button.determine' ),
		cancelButtonText: $t( 'button.cancel' )
	}).then(() => {
		// 目前只支持单文件，可以传orderID
		const array = flattenList( list.value );
		const attach = array.find(( a ) => checkList.value.includes( a.id ))
		softwareEvokeRef.value.handlePrintOut({
			orgID: orgID,
			orderID: attach.srcID,
			fileID: [attach.srcAttachID]
		})
	});
};

// 去切片
const handleGoSlice = () => {
	const array = flattenList( list.value );
	const arr = array.filter(( a ) => checkList.value.includes( a.id )).map(( item ) => ({
		id: item.id,
		orderID: item.srcID,
		filename: item.fileName,
		bucket: item.bucket,
		dfsID: item.dfsID,
		fileSize: item.fileLength
	}));
	let totalSize = 0;
	arr.forEach(( item ) => {
		totalSize += item.fileSize;
	});
	if ( totalSize > maxFileSize ) {
		XlMessage({
			type: 'error',
			message: $t( 'user.case.sliceOverSize', { maxFileSize: maxFileSize / ( 1024 * 1024 ).toFixed( 2 ) })
		});
	} else {
		const data = {
			orgID,
			ids: checkList.value
		}
		$store.commit( 'setDesignPreprintList', arr );
		const anyOne = array.find(( a ) => checkList.value.includes( a.id ));
		const printType = anyOne.printType; // 获取打印机类型
		const cate = list.value.find(( l ) => l.productConfigCode === anyOne.productConfigCode ); // 获取该类型
		submitToDelete( data, cate ,false );
		router.push({ name: 'PrinterSlice', query: { origin: `designOrder_${printType}`}})
	}
};

onMounted(() => {
	console.log( 'onMounted', JSON.stringify( addingInfo.value ));
});

onUnmounted(() => {
	Bus.$off( 'togglePreprintPanel', toggle );
});

</script>

<style lang="scss" scoped>
.list-block {
	width: 100%;
	height: 100%;
	flex-direction: column;
	position: relative;
	display: flex;
	&.hidden {
		flex-basis: auto !important;
		width: 0;
		.list-header,
		.list-content {
			display: none;
		}
	}
	&.inline {
		.list-header {
			height: 32px;
			margin-bottom: 10px;
			border-bottom: none;
			.title {
				font-size: 16px;
				border-left: 5px solid #5587ff;
				font-family: $font-family;
				padding-left: 8px;
				line-height: 1;
			}
		}
		.trigger {
			position: absolute;
			left: 0;
			margin-left: 0;
		}
	}
	.list-header {
		display: flex;
		height: 68px;
		margin-bottom: 16px;
		border-bottom: 2px solid #EFF1F7;
		align-items: center;
		justify-content: space-between;
		.title {
			font-size: 18px;
			font-weight: 700;
			color: #2c364e;
			font-family: $font-family65;
		}
		.btns {
			.xl-icon {
				margin-right: 4px;
			}
		}
	}
	.list-content {
		flex: 1;
		height: 0;
		.model_wrap{
			border-radius: 12px;
			padding: 10px 8px 18px;
			background: #F7F8FA;
			margin-bottom: 16px;
			.type_title{
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				color:#42526E;
				.title_wrap{
					padding-left: 24px;
					font-family: $font-family65;
				}
				.title_opera {
					display: flex;
					align-items: center;
					.title_opera_delete {
						padding: 0px 12px;
						border-right: 1px solid #E0E4EA;
						margin-right: 12px;
						display: flex;
						align-items: center;
						cursor: pointer;
						.iconfont {
							font-size: 18px;
							margin-right: 4px;
							line-height: 1;
						}
					}
					:deep(.el-checkbox){
						height: 22px;
					}
				}
			}
		}
		.check-wrap {
			:deep(.el-checkbox){
				width: 100%;
				height: 96px;
				margin-top: 8px;
				margin-right: 0;
				.el-checkbox__label {
					&:hover{
						background-color: #eff1f7;
					}
					background-color: white;
					border-radius: 10px;
					padding-left: 0;
					margin-left: 8px;
					flex: 1;
					width: 0;
				}
			}
			.check-card {
				display: flex;
				align-items: center;
				flex-direction:row;
				padding: 8px 12px;
				.left {
					height: 80px;
					width: 80px;
					text-align: center;
					display: flex;
					.img {
						width: 100%;
						height: 100%;
						object-fit: contain;
					}
				}
				.center {
					flex: 1;
					width: 0;
					padding: 0 12px;
					.info {
						font-size: 14px;
						line-height: 22px;
						height: 22px;
						color: #737e99;
						align-items: center;
						margin: 2px 0;
						display: flex;
						span {
							margin-left: 4px;
							flex: 1;
							width: 0;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}
				.right {
					width: 30px;
					.iconfont {
						color: #737E99;
						font-size: 20px;
					}
					
				}
			}
			.checked {
				border: 3px solid #5587FF;
				border-radius: 12px;
				background: #edf3ff
			}
		}
	}
}


.trigger {
	position: fixed;
	top: 50%;
	transform: translate(-100%, -50%);
	margin-left: -24px;
	width: 22px;
	height: 62px;
	cursor: pointer;
	img {
		height: 100%;
		width: 100%;
	}
}
</style>